import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import toast, { Toaster } from "react-hot-toast";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Header } from "antd/lib/layout/layout";
import PreferencesNav from "./PreferencesNav";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddIcon from "@mui/icons-material/Add";
import {
  addDepartment1,
  updateDepartment1,
  departmentList1,
  departmentUUID1,
  activeInactiveDept,
  getOrgList,
} from "../../services/index";
import { searchForMatch } from "../utils/textUtils";
import Loader from "../Common/Loader";
import Select from "react-select";
import { WAREHOUSE_URL } from "../../CONSTANTS";
import { callGetAxios } from "../../services/common/common";

const DepartmentList = () => {
  const defaultObj = {
    organisationId: "",
    organisationTitle: "",
    recordId: "",
    title: "",
    warehouseId: "",
    warehouseTitle: "",
  };

  const [record, setRecord] = useState(defaultObj);
  const [success, setSuccess] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setRecord(defaultObj);
    setShow(false);
  };
  const handleShow = () => setShow(true);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [rows, setRows] = useState([]);
  const [wareOptions, setWareOptions] = useState([]);
  const [orgOptions, setOrgOptions] = useState([]);

  const [dataId, setDataId] = useState(false);

  const columns = [
    {
      name: "DEPARTMENT TITLE",
      cell: (row) => row.title,
      width: "200px",
    },
    {
      name: "WAREHOUSE TITLE",
      cell: (row) => row.warehouseTitle,
      width: "200px",
    },
    {
      name: "ORGANISATION TITLE",
      cell: (row) => row?.organisationTitle,
      width: "400px",
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          {row.active ? (
            <CheckCircleIcon
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: "greenyellow",
              }}
              onClick={() => handleActiveInactive(row)}
            />
          ) : (
            <CancelIcon
              style={{ fontSize: "15px", cursor: "pointer", color: "tomato" }}
              onClick={() => handleActiveInactive(row)}
            />
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    getOrganizationList();
  }, []);

  const getOrganizationList = () => {
    getOrgList().then((res) => {
      if (res.errorCode === 0) {
        const options = res.responsePacket?.map((d) => ({
          key: d.recordLongId,
          value: d.recordId,
          label: d.organisationTitle,
        }));
        setOrgOptions(options);
      } else {
        toast(res);
      }
    });
  };

  const getWarehouseKeyValueList = (id) => {
    callGetAxios(
      WAREHOUSE_URL() + "getWarehouseByOrganisation/" + id,
      "WarehouseKeyValueById"
    ).then((res) => {
      if (res.errorCode === 0) {
        const options = res.responsePacket?.map((d) => ({
          value: d.recordId,
          label: d.title,
        }));
        setWareOptions(options);
        return options;
      } else {
        toast(res);
      }
    });
  };

  const handleSelect = (e, name) => {
    if (name === "org") {
      getWarehouseKeyValueList(e.key);
      setRecord((prev) => ({ ...prev, organisationId: e, warehouseId: {} }));
    } else {
      setRecord((prev) => ({ ...prev, warehouseId: e }));
    }
  };

  const handleActiveInactive = (row) => {
    activeInactiveDept(row.recordId).then((res) => {
      if (res.errorCode == 0) {
        setSuccess(!success);
        toast(res.message);
      } else {
        toast(res.message);
        return;
      }
    });
  };

  const handleSave = () => {
    if (!record.organisationId) {
      toast("Please select Organization");
      return;
    }
    if (!record.warehouseId) {
      toast("Please select Warehouse");
      return;
    }
    if (!record.title) {
      toast("Please fill title");
      return;
    }

    const data1 = {
      organisationId: record.organisationId?.value,
      organisationTitle: record.organisationId?.label,
      warehouseTitle: record.warehouseId?.label,
      warehouseId: record.warehouseId?.value,
      title: record?.title,
    };

    edit
      ? updateDepartment1(dataId, data1).then((res) => {
          if (res.errorCode == 0) {
            setSuccess(true);
            setRecord("");
            handleClose();
            toast(res.message, {
              autoClose: 2000,
            });
          } else {
            toast(res.message, {
              autoClose: 2000,
            });
            return;
          }
        })
      : addDepartment1(data1).then((res) => {
          if (res.errorCode == 0) {
            toast(res.message, {
              autoClose: 2000,
            });
            handleClose();
            setSuccess(true);
          } else {
            toast(res.message, {
              autoClose: 2000,
            });
            return;
          }
        });
  };

  const handleClicked = (id) => {
    departmentUUID1(id).then((res) => {
      if (res.errorCode === 0) {
        const response = res.responsePacket;
        const _organisationId = orgOptions?.find(
          (item) => item?.value === response?.organisationId
        );
        let _warehouseId;
        callGetAxios(
          WAREHOUSE_URL() + "getWarehouseByOrganisation/" + _organisationId.key,
          "WarehouseKeyValueById"
        ).then((res) => {
          if (res.errorCode === 0) {
            const options = res.responsePacket?.map((d) => ({
              value: d.recordId,
              label: d.title,
            }));
            setWareOptions(options);
            _warehouseId = options?.find(
              (item) => item?.value === response?.warehouseId
            );
            setRecord({
              ...record,
              recordId: response?.recordId,
              title: response?.title,
              organisationId: _organisationId,
              warehouseId: _warehouseId,
            });
          } else {
            toast(res);
          }
        });
      } else {
        toast(res.message);
        return;
      }
    });

    handleShow();
    setEdit(true);
  };

  useEffect(() => {
    var data = {
      page: 0,
      search: "",
      size: -1,
    };
    setLoading(true);
    departmentList1(data)
      .then((res) => {
        if (res.errorCode == 0) {
          var temp = res.responsePacket.data;
          setRows(temp);
          setFilteredData(temp);
          setLoading(false);
        } else {
          toast(res.message);
          setLoading(false);
          return;
        }
      })
      .catch((error) => setLoading(false));
  }, [success]);

  const handleSearch = (search) => {
    const result = rows.filter((data) => {
      return searchForMatch(data.title, search);
    });
    setFilteredData(result);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <Header>Department Info</Header>

          <br />
          <hr />
          <table>
            <tr>
              <td>Organization:</td>
              <Select
                options={orgOptions}
                value={record?.organisationId}
                onChange={(e) => handleSelect(e, "org")}
              />
            </tr>
            <tr>
              <td>Warehouse:</td>
              <Select
                options={wareOptions}
                value={record?.warehouseId}
                onChange={(e) => handleSelect(e, "ware")}
              />
            </tr>
            <tr>
              <td>Department Name:</td>
              <td>
                {" "}
                <input
                  autoComplete="off"
                  className="ember-text-field ember-view form-control"
                  type="text"
                  onChange={(e) => {
                    setRecord({ ...record, title: e.target.value });
                  }}
                  value={record?.title}
                />
              </td>
            </tr>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <div className="column list-column d-print-none column-small">
        <PreferencesNav />
      </div> */}
      <div className="column content-column">
        <div className="header clearfix" style={{ borderBottom: "none" }}>
          <span className="float-left" style={{ fontSize: "35px" }}>
            Department List
          </span>
        </div>
        <div className="fill-container">
          <div className="list-filter">
            <div
              id="ember1611"
              className="dropdown ember-view clearfix list-title"
            ></div>
          </div>
        </div>
        <div style={{ height: 500, width: "100%" }}>
          <DataTable
            columns={columns}
            data={filteredData}
            fixedHeader
            pagination
            pointerOnHover={true}
            highlightOnHover={true}
            onRowClicked={(data) => {
              setDataId(data.recordId);
              handleClicked(data.recordId);
            }}
            progressPending={loading}
            progressComponent={<Loader />}
            subHeader
            subHeaderComponent={
              <div className="d-flex align-items-center">
                <div className="input-group mr-2 paginationSearchInput">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      <SearchRoundedIcon />
                    </span>
                  </div>
                  <input
                    className="form-control"
                    placeholder={"Search here"}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                </div>
                <button
                  id="ember5839"
                  className="tooltip-container ember-view btn btn-primary d-flex align-items-center"
                  type="button"
                  onClick={handleShow}
                >
                  <AddIcon />
                  New
                </button>
              </div>
            }
          />
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default DepartmentList;
